export const FS_ACTION_TYPE__DOWNLOAD_ASPERA_PACKAGE = 'DOWNLOAD_ASPERA_PACKAGE_PORTAL';

export const FASPEX_FLAGS = {
  "N/A": 0,
  "Archieve": 1,
  "Inbox": 10,
  "Sent": 100,
}